module.exports = __webpack_public_path__ + "media/images/bright_yellow_star-79030ca4.svg";